import {css} from "lit";
import {iconStyles} from "./styles/Icons.js";
import {commonStyles} from "./styles/Common.js";

export const collapsibleSectionStyles = [commonStyles, iconStyles, css`
	.collapsible-section {
		display: flex;
		flex-direction: column;
		overflow: hidden;
		max-width: 100%;
	}

	.collapsible-section h2 {
		margin: 0;
	}

	.collapsible-section .btn-toggle {
		display: flex;
		align-items: center;
		margin: 5px 1px;
		padding: 5px 0 3px;
		background-color: transparent;
		border: none;
		font-family: var(--pn-font-family-base)
		cursor: pointer;
		width: 100%;
	}
	.collapsible-section .btn-toggle .icon-chevron-light-right {
		margin-right: 6px;
		font-size: var(--pn-font-size-small);
		transition: transform .2s;
	}
	.collapsible-section .btn-toggle .title {
		flex: 1;
		max-width: inherit;
		margin: 0;
		font-weight: 500;
		font-size: calc(var(--pn-font-size-base) + 2px);
		text-align: left;
		border-bottom: none; /* TODO: still needed? conflicting page styles */
	}
	.collapsible-section .btn-toggle .badget {
		display: none;
		position: absolute;
		margin-left: -7px;
		width: 8px;
		height: 8px;
		border-radius: 4px;
		background-color: var(--pn-outline-csh-notification-badge-color);
	}

	.collapsible-section .section-content {
		display: none;
	}
	.collapsible-section.open .section-content {
		display: block;
	}
	.collapsible-section.open .icon-chevron-light-right {
		transition: transform .2s;
		transform: rotate(90deg);
	}

	.collapsible-section.show-badge .btn-toggle .badget {
		display: inline-block;
	}
`];
